import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ImageUser from "../ImageUser/ImageUser";
import Heart from "../Heart/Heart";
import * as icons from "../../Context/exportIcons";
import { useContextHook } from "../../Context/ContextOPen";
import { useContextChat } from "../../Context/ContextChat";
import { checkToken, language, ltrDirection } from "../../Tools/APIs";
import balloon from "../../images/ballon.png";

const ProMemberCard = ({
  id,
  image,
  isOnline,
  name,
  age,
  city,
  country,
  status,
  marriageStatus,
  job,
  education,
  health,
  physique,
  skinColor,
  religiosity,
  prayer,
  hijab,
  beard,
  income,
  bio,
  facebook,
  instagram,
  twitter,
  tiktok,
  user,
  isCaring,
}) => {
  const { showMessagesSign, setShowBottomSheet, setMessageActivate } = useContextHook();
  const { isActive } = useContextChat();
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [windowWidth]);

  return (
    <Link to={`/view-profile/${id}`} className="block">
      <div
        style={ltrDirection}
        className="relative bg-gradient-to-br from-yellow-200 via-pink-100 to-pink-300 rounded-xl shadow-md hover:scale-105 transition-transform p-2 flex flex-col items-center text-center overflow-hidden h-full min-h-[280ظpx] justify-between"
      >
        <div className="absolute top-3 right-3 bg-yellow-400 text-white rounded-full px-3 py-1 flex items-center gap-1 font-bold text-sm shadow">
          <icons.IoMdStar className="text-yellow-700" />
          PRO
        </div>
        <ImageUser image={image} id={id} isOnline={isOnline} imgspa={true} className="w-16 h-16 mb-2 rounded-full border-2 border-pink-300 shadow" />
        <div className="font-extrabold text-base text-pink-700 mb-1 break-words w-full line-clamp-1">{name}</div>
        <div className="flex justify-center items-center gap-1 text-gray-600 text-sm mb-1">
          <span>{country && `${country}`}</span>
          <span>من</span>
          <span>سنة</span>
          <span>{age}</span>
        </div>
        {/* <div className="text-gray-500 text-sm mb-1 line-clamp-1">{city}</div> */}
        {/* <div className="flex flex-wrap justify-center gap-2 text-xs text-gray-700 mb-2 h-24 overflow-y-auto">
          {status && <span className="bg-pink-200 rounded px-2 py-0.5">{status}</span>}
          {marriageStatus && <span className="bg-pink-200 rounded px-2 py-0.5">{marriageStatus}</span>}
          {job && <span className="bg-yellow-200 rounded px-2 py-0.5">{job}</span>}
          {education && <span className="bg-yellow-100 rounded px-2 py-0.5">{education}</span>}
          {health && <span className="bg-green-100 rounded px-2 py-0.5">{health}</span>}
          {physique && <span className="bg-pink-100 rounded px-2 py-0.5">{physique}</span>}
          {skinColor && <span className="bg-yellow-100 rounded px-2 py-0.5">{skinColor}</span>}
          {religiosity && <span className="bg-yellow-200 rounded px-2 py-0.5">{religiosity}</span>}
          {prayer && <span className="bg-yellow-100 rounded px-2 py-0.5">{prayer}</span>}
          {hijab && <span className="bg-pink-100 rounded px-2 py-0.5">{hijab}</span>}
          {beard && <span className="bg-yellow-100 rounded px-2 py-0.5">{beard}</span>}
          {income && <span className="bg-green-100 rounded px-2 py-0.5">{income}</span>}
        </div> */}
        {/* {bio && <div className="text-gray-700 text-xs mb-2 italic line-clamp-2">{bio}</div>} */}
        <div className="flex justify-between items-center w-full px-1 py-1">
          <div className="flex items-center gap-1">
            <span className="font-light flex items-center max-md:text-sm text-ellipsis w-full line-clamp-1">
              {country + ` / ` + city}
            </span>
            <icons.IoLocationSharp color="#ff6589" fontSize={"1.5rem"} />
          </div>
          <div className="flex items-center gap-1">
            <img src={balloon} alt="" className="w-6 h-6" />
            <span className="font-light text-base max-md:text-sm text-ellipsis w-full line-clamp-1">{status}</span>
          </div>
        </div>
        <div className={`gap-2 p-2 mx-2 ${language === "ar" ? "flex justify-start" : "flex justify-end"}`}>
          {checkToken ? (
            <div
              onClick={e => {
                e.preventDefault();
                if (!isActive) setMessageActivate(true);
                else setShowBottomSheet([id, true]);
              }}
              className="flex items-center justify-center gap-1 p-2 rounded-full cursor-pointer text-center bg-Secondary text-black font-semibold"
            >
              <icons.BiMessageRoundedDetail size={18} className="hover:scale-125 transition-all duration-200" color="white" />
            </div>
          ) : (
            <div
              onClick={e => {
                e.preventDefault();
                showMessagesSign();
              }}
              className="flex items-center justify-center gap-1 p-2 rounded-full cursor-pointer text-center bg-Secondary text-black font-semibold"
            >
              <icons.BiMessageRoundedDetail size={18} className="hover:scale-125 transition-all duration-200" color="white" />
            </div>
          )}
          <Heart
            user={user}
            id={user?.login_details?.id}
            check={isCaring ? isCaring : user?.is_caring}
            className="mr-2 bg-slate-200 p-2 rounded-full"
          />
        </div>
        {/* <div className="flex justify-center gap-2 mt-2">
          {facebook && <a href={facebook} target="_blank" rel="noopener noreferrer"><icons.FaFacebook className="text-blue-600 hover:scale-125 transition" size={22} /></a>}
          {instagram && <a href={instagram} target="_blank" rel="noopener noreferrer"><icons.FaInstagram className="text-pink-500 hover:scale-125 transition" size={22} /></a>}
          {twitter && <a href={twitter} target="_blank" rel="noopener noreferrer"><icons.FaTwitter className="text-blue-400 hover:scale-125 transition" size={22} /></a>}
          {tiktok && <a href={tiktok} target="_blank" rel="noopener noreferrer"><icons.FaTiktok className="text-black hover:scale-125 transition" size={22} /></a>}
        </div> */}
      </div>
    </Link>
  );
};

export default ProMemberCard; 